import CheckboxFacet from '../../../../../../../components/Blocks/Search/CheckboxFacet';

export default CheckboxFacet;
